import { createSlice } from "@reduxjs/toolkit"

const DashboardSlice = createSlice({
  name: "Dashboard",
  initialState: {
    ProjDashboardStats: [],
    GlobalDashboardPriority:[],
    GlobalDashboardSeverity:[],
    GlobalDashboardReported:[],
    GlobalDashboardPartitionUser:[],
    GlobalDashboardProjectBreakdown:[],
    GlobalDashboardRequirementBreakDown:[],
    ProjectDashboardSeverityDef:[],
    ProjectDashboardStatusDef:[],
    ProjectDashboardTestCaseStatus:[],
    ProjectDashboardTestCaseExecuted:[],
    ProjectDashboardTestCaseFail:[],
    ProjectDashboardDefectReopen:[],
    ProjectDashboardDefectAging:[],
    ProjectDashboardActiveDefect:[],
    ProjectDashboardDefectClosure:[]
  },

  reducers: {
    setProjDashboardStats: (state, action) => ({
      ...state,
      ProjDashboardStats: action.payload,
    }),
    setGlobalDashboardSeverity: (state, action) => ({
      ...state,
      GlobalDashboardSeverity: action.payload,
    }),
    setGlobalDashboardPriority: (state, action) => ({
      ...state,
      GlobalDashboardPriority: action.payload,
    }),
    setGlobalDashboardReported: (state, action) => ({
        ...state,
        GlobalDashboardReported: action.payload,
      }),
      setGlobalDashboardPartitionUser: (state, action) => ({
        ...state,
        GlobalDashboardPartitionUser: action.payload,
      }),
      setGlobalDashboardProjectBreakdown: (state, action) => ({
        ...state,
        GlobalDashboardProjectBreakdown: action.payload,
      }),
      setGlobalDashboardRequirementBreakDown: (state, action) => ({
        ...state,
        GlobalDashboardRequirementBreakDown: action.payload,
      }),
      setProjectDashboardSeverityDef: (state, action) => ({
        ...state,
        ProjectDashboardSeverityDef: action.payload,
      }),
      setProjectDashboardStatusDef: (state, action) => ({
        ...state,
        ProjectDashboardStatusDef: action.payload,
      }),
      setProjectDashboardTestCaseStatus: (state, action) => ({
        ...state,
        ProjectDashboardTestCaseStatus: action.payload,
      }),
      setProjectDashboardTestCaseExecuted: (state, action) => ({
        ...state,
        ProjectDashboardTestCaseExecuted: action.payload,
      }),
      setProjectDashboardTestCaseFail: (state, action) => ({
        ...state,
        ProjectDashboardTestCaseFail: action.payload,
      }),
      setProjectDashboardDefectReopen: (state, action) => ({
        ...state,
        ProjectDashboardDefectReopen: action.payload,
      }),
      setProjectDashboardDefectAging: (state, action) => ({
        ...state,
        ProjectDashboardDefectAging: action.payload,
      }),
      setProjectDashboardActiveDefect: (state, action) => ({
        ...state,
        ProjectDashboardActiveDefect: action.payload,
      }),
      setProjectDashboardDefectClosure: (state, action) => ({
        ...state,
        ProjectDashboardDefectClosure: action.payload,
      }),
  },
})

export const { setProjDashboardStats ,setGlobalDashboardSeverity ,setGlobalDashboardPriority ,setGlobalDashboardReported , 
    setGlobalDashboardPartitionUser ,setGlobalDashboardProjectBreakdown ,setProjectDashboardSeverityDef ,setProjectDashboardStatusDef,
    setProjectDashboardTestCaseStatus , setProjectDashboardTestCaseExecuted , setProjectDashboardTestCaseFail ,
    setGlobalDashboardRequirementBreakDown ,setProjectDashboardDefectReopen ,setProjectDashboardDefectAging ,
    setProjectDashboardActiveDefect, setProjectDashboardDefectClosure} = DashboardSlice.actions

export default DashboardSlice.reducer
